module.exports = __webpack_public_path__ + "static/media/rear_corner_flipped.7560411e.png";